// extracted by mini-css-extract-plugin
export default {"contentfulWrapper":"styles-module__contentfulWrapper--NjhN8"};